/* Dansk katalog for locale-support-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'nav.support': 'Support',
  'navhelp.support': 'Se og følg op på supportsager, du har indsendt.',
  'route.support': 'Support',
  'support.title': 'Support',
  'support.contact': 'Kontakt support',
  'support.close': 'Luk',
  'support.send': 'Send',
  'support.sending': 'Sender…',
  'support.editor.toolbar': 'Formatering af besked',
  'support.editor.bold': 'Fed',
  'support.editor.italic': 'Kursiv',
  'support.editor.underline': 'Understreget',
  'support.editor.bullets': 'Punktliste',
  'support.editor.numbered': 'Nummereret liste',
  'support.editor.list': 'Liste',
  'support.editor.link': 'Link',
  'support.editor.linkPrompt': 'Indsæt et http://- eller https://-link',
  'support.editor.image': 'Billede',
  'support.editor.screenshot': 'Skærmbillede',
  'support.editor.screenshotLabel': 'Vedhæft et skærmbillede af den aktuelle visning',
  'support.editor.capturing': 'Tager skærmbillede…',
  'support.editor.pendingImages': 'Billeder klar til afsendelse',
  'support.editor.removeImage': 'Fjern billede',
  'support.editor.openImage': 'Åbn billede',
  'support.editor.optimizing': 'Optimerer billeder…',
  'support.retry': 'Prøv igen',
  'support.back': 'Tilbage til supportsager',
  'support.category': 'Kategori',
  'support.category.feil': 'Fejl / noget virker ikke',
  'support.category.fakturering': 'Fakturering og betaling',
  'support.category.sporsmal': 'Generelt spørgsmål',
  'support.category.annet': 'Andet',
  'support.subject': 'Emne',
  'support.subject.placeholder': 'Kort beskrivelse af sagen',
  'support.message': 'Besked',
  'support.message.placeholder': 'Beskriv, hvad der sker, gerne med detaljer',
  'support.sent.title': 'Supportsagen er sendt',
  'support.sent.text': 'Vi har modtaget {id} og vender tilbage hurtigst muligt.',
  'support.new.title': 'Ny supportsag',
  'support.new.action': 'Ny supportsag',
  'support.filter.label': 'Filtrer supportsager',
  'support.filter.all': 'Alle',
  'support.filter.open': 'Åbne',
  'support.filter.closed': 'Lukkede',
  'support.table.ticket': 'Sag',
  'support.table.category': 'Kategori',
  'support.table.sent': 'Sendt',
  'support.table.lastReply': 'Seneste svar',
  'support.lastReply.you': 'Dig',
  'support.lastReply.support': 'Support',
  'support.table.status': 'Status',
  'support.status.open': 'Åben',
  'support.status.closed': 'Lukket',
  'support.opened': 'Åbnet {date}',
  'support.closeTicket': 'Markér som lukket',
  'support.table.actions': 'Handlinger',
  'support.delete.rowAction': 'Slet',
  'support.delete.rowLabel': 'Slet henvendelse {{id}}',
  'support.delete.action': 'Slet henvendelse',
  'support.delete.title': 'Slet henvendelsen?',
  'support.delete.confirm': 'Slet',
  'support.delete.text': 'Henvendelsen fjernes fra din liste, og beskederne i den er ikke længere tilgængelige for dig.',
  'support.delete.done': 'Henvendelsen er slettet.',
  'support.error.delete': 'Henvendelsen kunne ikke slettes. Prøv igen.',
  'support.reopen.action': 'Genåbn',
  'support.reopen.title': 'Genåbn supportsagen?',
  'support.reopen.confirm': 'Genåbn alligevel',
  'support.reopen.text': 'Genåbn kun, hvis det gælder samme problem, som sagen oprindeligt handlede om. Er det en ny sag, så opret hellere en ny supportsag.',
  'support.you': 'Dig',
  'support.agent': 'Support',
  'support.reply.placeholder': 'Fortsæt samtalen – skriv en besked til support',
  'support.closed.note': 'Denne sag er lukket. Du kan se historikken, men ikke sende flere beskeder.',
  'support.empty.title': 'Ingen supportsager endnu',
  'support.empty.filterTitle': 'Ingen sager i dette filter',
  'support.empty.text': 'Sager, du indsender via supportknappen, vises her.',
  'support.loading.list': 'Henter supportsager…',
  'support.loading.thread': 'Henter samtalen…',
  'support.error.required': 'Indtast både emne og besked.',
  'support.error.noBusiness': 'Vælg en virksomhed, før du kontakter support.',
  'support.error.create': 'Kunne ikke sende supportsagen. Prøv igen.',
  'support.error.list': 'Kunne ikke hente supportsagerne.',
  'support.error.thread': 'Kunne ikke hente samtalen.',
  'support.error.reply': 'Kunne ikke sende beskeden. Prøv igen.',
  'support.error.status': 'Kunne ikke opdatere status.',
  'support.error.link': 'Indtast et gyldigt http://- eller https://-link.',
  'support.error.imageType': 'Brug billeder i JPEG-, PNG-, GIF- eller WebP-format.',
  'support.error.imageSourceSize': 'Hvert originalbillede må højst fylde 20 MB.',
  'support.error.imageSourceTotal': 'Originalbillederne må højst fylde 40 MB pr. valg.',
  'support.error.imageCount': 'Du kan vedhæfte op til fire billeder.',
  'support.error.imageSize': 'Et billede er stadig større end 5 MB efter optimering.',
  'support.error.imageTotal': 'Optimerede billeder må højst fylde 10 MB pr. besked.',
  'support.error.imageOptimize': 'Billedet kunne ikke optimeres. Prøv et mindre billede.',
  'support.error.screenshot': 'Kunne ikke tage skærmbilledet. Prøv igen, eller vedhæft et billede manuelt.',
  'support.error.imagesUnavailable': 'Afsendelse af billeder kræver den opdaterede supporttjeneste. Genindlæs, og prøv igen.',
  'support.error.requestTimedOut': 'Supporttjenesten svarede ikke. Prøv igen.',
  'support.page.tickets': 'Supportsager',
  'support.page.articles': 'Artikler',
  'support.articles.back': 'Tilbage til artikler',
  'support.articles.search.label': 'Søg i hjælpeartikler',
  'support.articles.categories': 'Kategorier',
  'support.articles.results': 'Artikler fundet: {count}',
  'support.articles.empty.title': 'Fandt ingen artikler',
  'support.articles.empty.text': 'Prøv et andet søgeord, eller vælg en anden kategori.',
  'support.articles.clear': 'Nulstil søgning og filter',
  'support.pages.label': 'Vælg supportside',
  'support.articles.search.placeholder': 'Søg i hjælpeartikler',
  'support.articles.count.one': '{count} artikel',
  'support.articles.count.other': '{count} artikler',
  'support.articles.resultsTitle': 'Søgeresultater',
  'err.nativeValidation.backend-support.1': 'Ugyldigt svar ved sletning af supportsagen.',
});
